import { useMutation } from '@tanstack/vue-query';

export type ExclusiveSalesOfferPayload = {
  catalogueProjectId: number;
  catalogueUnitId: number;
  clientName?: string;
  hideDeveloper?: boolean;
};

type ExclusiveSalesOfferResponse = { success: true; data: { offerUrl: string | null; unitNumber: string } };

// "Prepare sales offer" on an exclusive unit: the Insiders PDF for that catalogue unit (no price hold, no deal).
export const useExclusiveSalesOffer = () => {
  const authStore = useAuthStore();
  return useMutation({
    mutationFn: ({ catalogueProjectId, catalogueUnitId, clientName, hideDeveloper }: ExclusiveSalesOfferPayload) =>
      $fetch<ExclusiveSalesOfferResponse>(
        `/api/exclusives/${catalogueProjectId}/units/${catalogueUnitId}/sales-offer`,
        {
          method: 'POST',
          headers: { Authorization: `Bearer ${authStore.token}` },
          body: { clientName, hideDeveloper },
        },
      ).then((res) => res.data),
    onError: (error) => useErrorHandler().catchErrors(error),
  });
};
